
import {
    Vue,
    Component,
    Prop,
    Emit,
    Watch,
} from 'vue-property-decorator';

@Component({
    name: 'Dialog',
    components: {},
})
export default class Dialog extends Vue {
    @Prop({
        type: Number,
    })
    private delay?: number;

    @Prop({
        type: Boolean,
        default: false,
    })
    private visible!: boolean;

    private countdown: number = 0;
    private timer: any = 0;

    @Watch('visible')
    public visibleChange(n: any, o: any) {
        if (n && this.delay) {
            this.countdown = this.delay;
            this.play();
        }
    }

    @Emit('cancel')
    public cancel() {
        this.updateVisible();
        return true;
    }

    @Emit('confirm')
    public confirm() {
        this.updateVisible();
        return true;
    }

    public updateVisible(): void {
        this.$emit('update:visible', false);
    }

    public play() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        if (this.countdown) {
            this.timer = setTimeout(() => {
                this.countdown--;
                this.play();
            }, 1000);
        }
    }

    private mounted() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
}
